/*
 *  Copyright (c) 2013-2018 Acronis Incorporated. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

/* Filters */

angular.module('access.Utils')
    .filter('whiteLabel', ['Settings', 'escapeHTMLFilter', function (Settings, escapeHTMLFilter) {
        var
            PRODUCT_NAME_PLACEHOLDER_PATTERN = new RegExp('\\[PRODUCT_NAME\\]', 'g'),
            rawWhiteLabel = Settings['white_label'],
            escapedWhiteLabel = escapeHTMLFilter(rawWhiteLabel);

        return function (input, options) {
            if (!input) {
                return input;
            }

            return input.replace(
                PRODUCT_NAME_PLACEHOLDER_PATTERN,
                options && options.escapeHTML ? escapedWhiteLabel : rawWhiteLabel
            );
        }
    }]);
